module.exports = __webpack_public_path__ + "img/Kiniksa_logo@2x.d1733f70.png";